// スタイルシートを読み込む
import "./scss/_reset.scss";
import "./scss/common.scss";
import "./scss/swiper.scss";
import "./scss/front-page.scss";
import "./scss/about.scss";
import "./scss/program.scss";
import "./scss/post.scss";

import jQuery from "jquery";
import ScrollMagic from "scrollmagic";

const $ = jQuery;



$(window).on('load', function(){
	var tags = '.fadein, .fadein > li, .fadein > a, h1, h2, h3, h4, h5, h6, p, figure, .note, time, dt, dd, nav, .wp-pagenavi, table';
	$(tags).not('.no-fadein').css('opacity', 0);
	var controller = new ScrollMagic.Controller();
	$(tags).not('.no-fadein').each(function (i, node) {
        var scene = new ScrollMagic.Scene({
            triggerElement: node,
            triggerHook: "onEnter",
            reverse: false,
        })
            .setClassToggle(node, "motion")
            .addTo(controller);
    });

	$('#loading, #wrap').addClass('active');
	
	$('#nav-btn').on('click', function() {
		$('#g-nav').fadeToggle(300);
		$('#nav-btn, #nav-btn-icon').toggleClass('close');
	});

});

$(window).on('load resize', function(){
	var w = $(window).width();
	var scrollMargin;

	if(w > 1024){
		scrollMargin = 0;
		$('#g-nav').show();
		$('#nav-btn, #nav-btn-icon').removeClass('close');

		$('.has-children').on({
			'mouseenter' : function(){
				$(this).find('.children-list').fadeIn(0);
			},
			'mouseleave' : function(){
				$(this).find('.children-list').fadeOut(0);
			}
		});


	} else {
		scrollMargin = 60;
		$('#g-nav').hide();
	}

	$('a[href^="#"]').on('click', function () {
		var speed = 400,
		easing = "swing",
		href = $(this).attr("href"),
		target = $(href == "#" || href == "" ? 'html' : href),
		position = target.offset().top - scrollMargin;
		$('body,html').animate({scrollTop: position}, speed, easing);
		return false;
	});

	var anchorFlg = true;
	if(anchorFlg === true) {
		var url = $(location).attr('href');
		if(url.indexOf("?id=") != -1){
			var id = url.split("?id=");
			var t_target = $('#' + id[id.length - 1]);
			if(t_target.length){
					var pos = t_target.offset().top - scrollMargin;
					$("html, body").animate({scrollTop:pos}, 0);
			}
		}
		anchorFlg = false;
	}
});
